import { createContext } from "react";
const MenuContext = createContext({
    selectedItem: "",
    focusItem: "",
    multiSelect: false,
    setSelectedItem: () => null,
    setFocusItem: () => null,
    isContentWidth: false,
});
export default MenuContext;
//# sourceMappingURL=MenuContext.js.map